// Spec 078 — segredos que viajam NA URL (o link de exibição da TV: `/display/<token>/...`).
// Mora aqui, e não no logger da API, porque a URL crua chega a MAIS de um destino: o request log
// do Pino, o `scope.setExtra("url", req.url)` do Sentry (hook `onError`, que roda para TODO erro,
// inclusive o 404 de link revogado) e qualquer sink futuro. Um segredo novo na URL vira UMA
// entrada nesta lista, não uma redação por sink — que é exatamente o que se esquece.
const URL_SECRETS: ReadonlyArray<RegExp> = [
  // token opaco de 32 bytes em base64url (43 chars); a faixa cobre variações de padding.
  /(\/display\/)[A-Za-z0-9_-]{40,64}(?=\/|\?|$)/g,
];

/** Devolve a URL com todo segredo conhecido trocado por `[redacted]`. */
export function redactUrlSecrets(url: string): string {
  let out = url;
  for (const re of URL_SECRETS) out = out.replace(re, "$1[redacted]");
  return out;
}
